<template>
  <div class="holder-table">
    <AGGridWrapper
      v-if="dataMismatch.length"
      :column-defs="columnDefs"
      :row-data="dataMismatch"
      :grid-height="'67vh'"
      :storage-key="'no-match-table'"
      :no-rows-overlay-params="noRowsOverlayConfig"
      :loading="loadFlag"
      :row-selection="'none'"
    >
      <template #pagination>
        <pagination
          v-if="dataMismatch.length && totalPages !== 1"
          v-model="page"
          :total-pages="totalPages"
        />
      </template>
    </AGGridWrapper>
    <div v-else class="empty-table">
      No data found.
    </div>
  </div>
</template>

<script>
import AGGridWrapper from '@/components/grid/AGGridWrapper.vue';
import {createColumnDef, createSortableHeaderColumn} from '@/components/grid/AGGridCellRenderers.js';
import {ASC, DESC} from '@/constants/const';
import Pagination from '@/components/common/Pagination.vue';
import debounce from '@/mixins/debounce';
import linkGenerator from '@/constants/linkGen';
import errorHandler from '@/mixins/errorHandler';
import parseDate from '@/mixins/parseDate';
import parseDateTime from '@/mixins/parseTime';
import capitalizeEveryWord from '@/mixins/capitalizeEveryWord';
import EmailIcon from '@/components/icons/EmailIcon.vue';
import PhoneIcon1016 from '@/components/icons/PhoneIcon1016.vue';
import DateIcon16 from '@/components/icons/DateIcon16.vue';
import WhiteClockIcon16 from '@/components/icons/WhiteClockIcon16.vue';
import NoCaseActionsIcon from '@/components/icons/NoCaseActionsIcon.vue';

export default {
  name: 'DashboardNoMatchTable',
  components: {
    AGGridWrapper,
    Pagination,
  },
  mixins: [debounce, errorHandler, parseDate, parseDateTime, capitalizeEveryWord],
  props: {
    userEmail: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      caseName: '',
      sortBy: 'collectionDate',
      order: DESC,
      DESC,
      ASC,
      dataMismatch: [],
      totalPages: 0,
      page: 1,
      size: 8,
      loadFlag: false,
      noRowsOverlayConfig: {
        filterable: false,
        icon: NoCaseActionsIcon,
        text: 'No data found',
        actionText: null,
        onAction: null,
      },
    };
  },
  computed: {
    columnDefs() {
      return [
        createColumnDef({
          headerName: 'Custodian email',
          field: 'email',
          width: 150,
          minWidth: 150,
          headerComponent: 'AGGridHeaderWithIcon',
          headerComponentParams: {
            icon: EmailIcon,
            headerName: 'Custodian email',
          },
          cellRenderer: 'AGGridTextCell'
        }),

        createColumnDef({
          headerName: 'Device Id',
          field: 'deviceId',
          width: 150,
          minWidth: 115,
          headerComponent: 'AGGridHeaderWithIcon',
          headerComponentParams: {
            icon: PhoneIcon1016,
            text: 'Device Id'
          },
          cellRenderer: 'AGGridTextCell'
        }),

        createSortableHeaderColumn({
          headerName: 'Date of collection',
          field: 'dateCollection',
          width: 150,
          minWidth: 150,
          icon: DateIcon16,
          sortBy: 'collectionDate',
          onHeaderClick: this.sortedBy,
          cellRenderer: 'AGGridTextCell',
        }),

        createColumnDef({
          headerName: 'Time of collection',
          field: 'timeCollection',
          width: 150,
          minWidth: 100,
          headerComponent: 'AGGridHeaderWithIcon',
          headerComponentParams: {
            icon: DateIcon16,
            text: 'Time of collection'
          },
          cellRenderer: 'AGGridTextCell',
        }),

        createColumnDef({
          headerName: 'Data sources',
          field: 'dataSources',
          width: 150,
          minWidth: 150,
          headerComponent: 'AGGridHeaderWithIcon',
          headerComponentParams: {
            icon: WhiteClockIcon16,
            text: 'Data sources'
          },
          cellRenderer: 'AGGridTextCell',
          valueFormatter: (params) => {
            return this.capitalizeEveryWord(params.value.replaceAll(',', ' ')).replaceAll(' ', ', ');
          }
        })
      ];
    },
  },
  watch: {
    page() {
      this.getMismatchData();
    }
  },
  mounted() {
    this.getMismatchData();
  },
  methods: {
    linkGen(pageNum) {
      return linkGenerator(pageNum, `/cases/${this.$route.params.slug}/matching`);
    },
    sortedBy({sortBy, order}) {
      this.order = order;
      this.sortBy = sortBy;
      this.getMismatchData();
    },
    getMismatchData() {
      this.$load(async () => {
          this.loadFlag = true;
          const res = await this.$api.mismatch.getNoMatchData({
            page: this.page,
            size: this.size,
            userSpecificCases: true,
            keySearch: '',
            dateFrom: '',
            dateTo: '',
            caseId: '',
            deviceType: '',
            sources: '',
            sortOrder: this.order,
          });
          this.dataMismatch = res.data.body.content;
          this.totalPages = res.data.body.totalPages;
          this.debounce(() => this.loadFlag = false, 1000);
        }, (error => {
          this.handleResponseError(error);
          this.debounce(() => this.loadFlag = false, 1000);
        })
      );
    },
  }
};
</script>

<style scoped>
.empty-table {
  text-align: center;
}
</style>
